import { __rest } from "tslib";
import { refineModelForRequest } from '@/client/formatters/utils';
const formatRedirectTriggers = (triggerTerms, triggerType) => triggerTerms.map((term) => ({
    type: triggerType,
    value: term,
}));
export const formatRedirect = (_a) => {
    var { copyable = true, triggerType, triggers } = _a, model = __rest(_a, ["copyable", "triggerType", "triggers"]);
    const requestModel = refineModelForRequest(model);
    return Object.assign(Object.assign({}, requestModel), { copyable, triggers: formatRedirectTriggers(triggers, triggerType) });
};
export default formatRedirect;
